"use strict";

exports.__esModule = true;
exports.createTimeScale = createTimeScale;
var _d3Scale = require("d3-scale");
/**
 * Create a time scale for the given timestamp values.
 * Note: The values _must_ be sorted.
 */
function createTimeScale(from, to, values) {
  var start = values[0];
  var end = values[values.length - 1];
  var smallestGap = 0;
  var last;
  for (var i = 0; i < values.length; i++) {
    if (typeof values[i] === "number") {
      var value = values[i];
      if (last === undefined) {
        last = value;
      } else if (smallestGap === undefined || value - last < smallestGap) {
        smallestGap = value - last;
      }
      last = value;
    }
  }
  if (smallestGap === undefined) {
    smallestGap = 864000000;
  }
  var domainEnd = typeof end === "number" ? end + smallestGap : end;
  return (0, _d3Scale.scaleUtc)().rangeRound([from, to]).domain([start, domainEnd]);
}